declare module PIXI {
    var spine: typeof pixi_spine
}

(PIXI as any).spine = pixi_spine;
